import React, { useMemo, useRef } from 'react';
import cn from 'classnames';

import arrived from 'assets/images/glossary/GlossaryArrived.svg';
import cancelled from 'assets/images/glossary/GlossaryCancelled.svg';
import confirmed from 'assets/images/glossary/GlossaryConfirmed.svg';
import dr from 'assets/images/glossary/GlossaryDepositRequested.svg';
import newclient from 'assets/images/glossary/GlossaryNewClient.svg';
import notes from 'assets/images/glossary/GlossaryNotes.svg';
import DropdownFoldout from 'components/generic/DropdownFoldout.component';
import { GLOSSARY_CURRENCY_ICONS } from 'constants/currency.const';
import { useCountryImage } from 'hooks/useCountryImage.hook';
import useOnClickOutside from 'hooks/useOnClickOutsideRef.hook';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import FaqButton from 'scheduler/components/common/FaqButton.component';

import CN from './GlossaryIcons.module.scss';

const getMenuItems = (depositedImg) => [
  {
    id: 1,
    titleTransKey: 'scheduler.header.glossaryIcons.confirmedClient',
    imgSrc: confirmed,
  },
  {
    id: 2,
    titleTransKey: 'scheduler.header.glossaryIcons.cancelledClient',
    imgSrc: cancelled,
  },
  {
    id: 3,
    titleTransKey: 'scheduler.header.glossaryIcons.arrivedClient',
    imgSrc: arrived,
  },
  {
    id: 4,
    titleTransKey: 'scheduler.header.glossaryIcons.clientPaidDeposit',
    imgSrc: depositedImg,
  },
  {
    id: 5,
    titleTransKey: 'scheduler.header.glossaryIcons.notPaidRequestedDeposit',
    imgSrc: dr,
  },
  {
    id: 6,
    titleTransKey: 'scheduler.header.glossaryIcons.specificNotes',
    imgSrc: notes,
  },
  {
    id: 7,
    titleTransKey: 'scheduler.header.glossaryIcons.newClient',
    imgSrc: newclient,
  },
];

const GlossaryIcons = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const depositedImg = useCountryImage(GLOSSARY_CURRENCY_ICONS);

  const menuItems = useMemo(() => getMenuItems(depositedImg), [depositedImg]);

  const wrapperRef = useRef(null);

  const { val: isRendered, tip: toggle, nay: close } = useTip(false);

  useOnClickOutside(wrapperRef, close);

  return (
    <div
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
      data-bem="GlossaryIcons"
      ref={wrapperRef}
    >
      <FaqButton tag="GlossaryIcons" onClick={toggle} active={isRendered} />

      {isRendered && (
        <DropdownFoldout width="lg" position="glossaryButton">
          <DropdownFoldout.Header>
            <div className={CN.dropdownTitle}>{t('scheduler.header.glossaryIcons.title')}</div>
          </DropdownFoldout.Header>
          <DropdownFoldout.Body>
            <div className={CN.panel}>
              <ul className={CN.list}>
                {menuItems.map((item) => (
                  <li key={item.id} className={CN.item}>
                    <img src={item.imgSrc} alt="" className={CN.icon} />
                    <span className={CN.title}>{t(item.titleTransKey)}</span>
                  </li>
                ))}
              </ul>
            </div>
          </DropdownFoldout.Body>
        </DropdownFoldout>
      )}
    </div>
  );
};

export default GlossaryIcons;
